import React from 'react'
import { useNavigate } from 'react-router-dom'
import { clearAuthData, getUserInfoSync, BASE_URL } from '../../config/api'
import logo from '../../assets/logo.jpeg'

const TopBar = ({ onToggleSidebar, setActiveScreen }) => {
  const navigate = useNavigate()
  const userInfo = getUserInfoSync()
  const companyLogo = userInfo?.company?.logo
  const logoSrc = companyLogo
    ? (companyLogo.startsWith('http') ? companyLogo : `${BASE_URL}${companyLogo}`)
    : logo

  // Get user display name
  const getUserDisplayName = () => {
    if (userInfo?.employee_name) return userInfo.employee_name
    if (userInfo?.full_name) return userInfo.full_name
    if (userInfo?.first_name && userInfo?.last_name) return `${userInfo.first_name} ${userInfo.last_name}`
    if (userInfo?.username) return userInfo.username
    if (userInfo?.email) return userInfo.email.split('@')[0]
    return 'User'
  }

  const handleProfileClick = (e) => {
    e.preventDefault()
    if (setActiveScreen) {
      setActiveScreen('profile')
    }
  }

  const handleToggleClick = (e) => {
    e.preventDefault()
    if (onToggleSidebar) {
      onToggleSidebar()
    }
  }

  const handleLogout = (e) => {
    e.preventDefault()
    clearAuthData()
    navigate('/login')
  }

  return (
    <header id="header" className="header fixed-top d-flex align-items-center">
      <div className="d-flex align-items-center justify-content-between">
        <a href="index.html" className="logo d-flex align-items-center">
          <img src={logoSrc} alt="Logo" />
          <span className="d-none d-lg-block">{userInfo?.company?.name || 'Sell Smart'}</span>
        </a>
        <i className="bi bi-list toggle-sidebar-btn" onClick={handleToggleClick} style={{ cursor: 'pointer' }} />
      </div>{/* End Logo */}

      <nav className="header-nav ms-auto">
        <ul className="d-flex align-items-center">
          <li className="nav-item d-block d-lg-none">
            <a className="nav-link nav-icon search-bar-toggle " href="#">
              <i className="bi bi-search" />
            </a>
          </li>{/* End Search Icon*/}
          <li className="nav-item dropdown">
            <a className="nav-link nav-icon" href="#" data-bs-toggle="dropdown">
              <i className="bi bi-bell" />
              <span className="badge bg-primary badge-number">4</span>
            </a>{/* End Notification Icon */}
            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow notifications">
              <li className="dropdown-header">
                You have 4 new notifications
                <a href="#"><span className="badge rounded-pill bg-primary p-2 ms-2">View all</span></a>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li className="notification-item">
                <i className="bi bi-exclamation-circle text-warning" />
                <div>
                  <h4>Lorem Ipsum</h4>
                  <p>Quae dolorem earum veritatis oditseno</p>
                  <p>30 min. ago</p>
                </div>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li className="notification-item">
                <i className="bi bi-x-circle text-danger" />
                <div>
                  <h4>Atque rerum nesciunt</h4>
                  <p>Quae dolorem earum veritatis oditseno</p>
                  <p>1 hr. ago</p>
                </div>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li className="notification-item">
                <i className="bi bi-check-circle text-success" />
                <div>
                  <h4>Sit rerum fuga</h4>
                  <p>Quae dolorem earum veritatis oditseno</p>
                  <p>2 hrs. ago</p>
                </div>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li className="notification-item">
                <i className="bi bi-info-circle text-primary" />
                <div>
                  <h4>Dicta reprehenderit</h4>
                  <p>Quae dolorem earum veritatis oditseno</p>
                  <p>4 hrs. ago</p>
                </div>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li className="dropdown-footer">
                <a href="#">Show all notifications</a>
              </li>
            </ul>{/* End Notification Dropdown Items */}
          </li>{/* End Notification Nav */}
          <li className="nav-item dropdown">
            <a className="nav-link nav-icon" href="#" data-bs-toggle="dropdown">
              <i className="bi bi-chat-left-text" />
              <span className="badge bg-success badge-number">3</span>
            </a>{/* End Messages Icon */}
            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow messages">
              <li className="dropdown-header">
                You have 3 new messages
                <a href="#"><span className="badge rounded-pill bg-primary p-2 ms-2">View all</span></a>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li className="message-item">
                <a href="#">
                  <img src="assets/img/messages-1.jpg" alt className="rounded-circle" />
                  <div>
                    <h4>Maria Hudson</h4>
                    <p>Velit asperiores et ducimus soluta repudiandae labore officia est ut...</p>
                    <p>4 hrs. ago</p>
                  </div>
                </a>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li className="message-item">
                <a href="#">
                  <img src="assets/img/messages-2.jpg" alt className="rounded-circle" />
                  <div>
                    <h4>Anna Nelson</h4>
                    <p>Velit asperiores et ducimus soluta repudiandae labore officia est ut...</p>
                    <p>6 hrs. ago</p>
                  </div>
                </a>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li className="message-item">
                <a href="#">
                  <img src="assets/img/messages-3.jpg" alt className="rounded-circle" />
                  <div>
                    <h4>David Muldon</h4>
                    <p>Velit asperiores et ducimus soluta repudiandae labore officia est ut...</p>
                    <p>8 hrs. ago</p>
                  </div>
                </a>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li className="dropdown-footer">
                <a href="#">Show all messages</a>
              </li>
            </ul>{/* End Messages Dropdown Items */}
          </li>{/* End Messages Nav */}
          <li className="nav-item dropdown pe-3">
            <a className="nav-link nav-profile d-flex align-items-center pe-0" href="#" data-bs-toggle="dropdown">
              <img src="assets/img/profile-img.jpg" alt="Profile" className="rounded-circle" />
              <span className="d-none d-md-block dropdown-toggle ps-2">{getUserDisplayName()}</span>
            </a>{/* End Profile Iamge Icon */}
            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
              <li className="dropdown-header">
                <h6>{getUserDisplayName()}</h6>
                <span>{userInfo?.role_display || 'User'}</span>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li>
                <a className="dropdown-item d-flex align-items-center" href="#" onClick={handleProfileClick} style={{ cursor: 'pointer' }}>
                  <i className="bi bi-person" />
                  <span>My Profile</span>
                </a>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li>
                <a className="dropdown-item d-flex align-items-center" href="#" onClick={handleLogout} style={{ cursor: 'pointer' }}>
                  <i className="bi bi-box-arrow-right" />
                  <span>Sign Out</span>
                </a>
              </li>
            </ul>{/* End Profile Dropdown Items */}
          </li>{/* End Profile Nav */}
        </ul>
      </nav>{/* End Icons Navigation */}
    </header>

  )
}

export default TopBar